'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.url = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _maps = require('../maps');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_FILTER_OBJ = {
    query: {}
};

var DEFAULT_URL_PARTS = {
    basename: undefined,
    directory: undefined,
    slug: undefined,
    filters: DEFAULT_FILTER_OBJ,
    search: {}
};

var StoreURL = function () {
    function StoreURL() {
        var _this = this;

        _classCallCheck(this, StoreURL);

        this.getSearch = function (search) {
            if ((typeof search === 'undefined' ? 'undefined' : _typeof(search)) === 'object') {
                //handle null which is an object
                return search || {};
            }
            var searchObj = {};
            try {
                searchObj = search.split("?").pop().replace(/\&$/, "").replace(/(\?|\&amp;)/g, "&");
                searchObj = JSON.parse('{"' + decodeURI(searchObj).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
            } catch (e) {
                return {};
            }

            return searchObj;
        };

        this.parseFilters = function (filters) {
            if (!filters) return DEFAULT_FILTER_OBJ;
            return filters.split('&').reduce(function (result, query, index) {
                var q = query.split("=");
                if (q.length === 1 && index === 0) {
                    result.pg = decodeURIComponent(q.pop());
                } else {
                    var _q = _slicedToArray(q, 2),
                        key = _q[0],
                        value = _q[1];

                    if (!key || !value) return result;
                    var decodedKey = decodeURIComponent(key);
                    var decodedValue = value.split("+").map(function (val) {
                        return decodeURIComponent(val);
                    });
                    result.query = result.query || {};
                    result.query[decodedKey] = (result.query[decodedKey] || []).concat(decodedValue);
                }
                return result;
            }, {});
        };

        this.getFilterString = function (filtersObj) {
            var caseSensative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!filtersObj) return '';
            var filters = encodeURIComponent(filtersObj.pg ? filtersObj.pg : "");
            var _filtersObj$query = filtersObj.query,
                query = _filtersObj$query === undefined ? {} : _filtersObj$query;
            //sort keys

            var keys = Object.keys(query).sort();
            filters += keys.reduce(function (result, key, index) {
                var values = query[key];
                var isStringDelimted = typeof values === 'string';
                if (isStringDelimted) {
                    values = values.split(",");
                }
                //filter out unsupported month format
                values = key.toLowerCase() === 'month' ? values.filter(function (v) {
                    return v in _maps.MonthMap;
                }) : values;

                //sort and encode values
                var val = values.sort(function (a, b) {
                    //special sort consideration for month names
                    var aValue = isNaN(a) ? _maps.MonthMap[a] || a : a * 1;
                    var bValue = isNaN(b) ? _maps.MonthMap[b] || b : b * 1;
                    if (aValue < bValue) {
                        return -1;
                    }
                    if (aValue > bValue) {
                        return 1;
                    }
                    return 0;
                }).map(function (val) {
                    return encodeURIComponent(val).replace(/\./, '%2E');
                }).join('+');
                //encode key and create key value string
                var q = encodeURIComponent(key).replace(/\./, '%2E') + '=' + val;
                var delimeter = index > 0 ? '&' : '';
                result += '' + delimeter + q;
                return result;
            }, filters && keys.length > 0 ? "&" : "");
            return caseSensative ? filters : filters.toLowerCase();
        };

        this.sortFilterString = function (filters) {
            return _this.getFilterString(_this.parseFilters(filters));
        };

        this.parseUrl = function (url) {
            var withUrlKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var envBasename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'app';

            if (!url) {
                return DEFAULT_URL_PARTS;
            }
            var protocol = (url.match(/^(?:(ht|f)tp(s?)\:\/\/)?/) || [])[0];
            if (protocol && protocol.indexOf(":") > -1) {
                url = url.replace(protocol, "");
            }

            var _url$split = url.split("?"),
                _url$split2 = _slicedToArray(_url$split, 2),
                baseUrl = _url$split2[0],
                search = _url$split2[1];

            var basename = envBasename.replace(/^\/|\/$/ig, '');
            //replace the basename if it exists un baseUrl
            var baseNameRegx = new RegExp('^' + basename + '/');
            baseUrl = baseUrl.replace(/^\//, "").replace(baseNameRegx, "");
            var urlSplit = baseUrl.split("/").filter(function (p) {
                return p !== "";
            });

            var _urlSplit$slice = urlSplit.slice(-3),
                _urlSplit$slice2 = _slicedToArray(_urlSplit$slice, 3),
                directory = _urlSplit$slice2[0],
                slug = _urlSplit$slice2[1],
                filters = _urlSplit$slice2[2];

            var urlParts = {
                basename: basename,
                directory: directory,
                slug: slug,
                filters: _this.parseFilters(filters),
                search: _this.getSearch(search)

                /*
                generate url key for give path, basically the sorted version of a url
                this could be updated to include url query params.
                This is primary useful for patch a path to path specific SEO information
                */
            };if (withUrlKey) {
                urlParts.urlKey = {
                    root: [directory, slug].join("/"),
                    fullKey: [directory, slug, _this.getFilterString(urlParts.filters)].join("/").replace(/\/$/, "")
                };
            }

            return urlParts;
        };

        this.getRelativePath = function (href) {
            return href.replace(/^(?:\/\/|[^\/]+)*(\/|$)/, "/");
        };

        this.getAbsoluteRedirectPath = function (url, host) {
            var basename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
            var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            var pat = /^https?:\/\/|^\/\//i;
            //remove trailing slash from url
            var redirectUrl = url;

            if (!pat.test(url) && host) {
                //replace leading app path if it exists
                redirectUrl = redirectUrl.replace(new RegExp("(^|^\/)" + basename + "\/"), "/");
                redirectUrl = '' + (basename !== redirectUrl ? basename : '') + (redirectUrl[0] === '/' ? '' : '/') + redirectUrl;
                redirectUrl = [host, redirectUrl.charAt(0) === "/" ? redirectUrl.substr(1) : redirectUrl].join("/");
                //remove trailing slash
                redirectUrl = redirectUrl.replace(/\/+$/, "");
            }

            //forward along query parameters if
            var querystring = Object.keys(query).reduce(function (a, c, i) {
                return '' + a + (!i ? '' : '&') + c + '=' + query[c];
            }, '');
            if (!!querystring) redirectUrl += '?' + querystring;

            return redirectUrl;
        };
    }

    /**
     * Takes the filter portion of the url and sorts it
     * @return {[type]} [description]
     */


    /**
     * Returns relative path for both absolute and relative urls.
     * http://hp.com/           -> /
     * https://hp.com/rel/url   -> /rel/url
     * @param  {String}  url        href url to get relative path from.
     * @param  {Boolean} withUrlKey If true return urlKey value which is sorted identifer for a given url
     * @return {Object}             Parsed url broken into object map
     */


    /**
     * Takes and url and host and creates an absolute redirect link
     * @param  {String} url   Destination url of redirect
     * @param  {String} host  The host, used to create the absolute path if url is relative
     * @param  {String} basename Optional basename for relative links to be forwarded in redirect
     * @param  {String} query Optional query parameters to be forwarded in redirect
     * @return {String}       The aboslute path url
     */


    _createClass(StoreURL, [{
        key: 'cleanupSlashes',


        /**
         * Will transform:
         *    "/laptops/"               into "/laptops"
         *    "///laptops///zbook///"   into "/laptops/zbook"
         *    "slp/////weekly/deals/"   into "slp/weekly/deals"
         */
        value: function cleanupSlashes(path) {
            if (typeof path !== 'string' || !path.length) {
                return '';
            }

            // delete duplicate slashes anywhere in the string
            var result = path.replace(/\/\/+/g, '/');

            // remove trailing slash
            if (result.substring(result.length - 1) === '/') {
                result = result.substring(0, result.length - 1);
            }

            return result;
        }
    }, {
        key: 'urlValidator',
        value: function urlValidator(string) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(string);
        }
    }, {
        key: 'addUrlProtocol',
        value: function addUrlProtocol(string) {
            if (!string.match(new RegExp('^(https:\\/\\/)', 'i'))) {
                if (string.includes('//')) {
                    return string.replace(/(^\w+:?|^)\/\//, 'https://');
                } else {
                    return 'https://' + string;
                }
            } else {
                return string;
            }
        }

        /**
         * Givent product variants and a url, maps to the associated product variant
         */

    }, {
        key: 'selectVariantFromQuery',
        value: function selectVariantFromQuery(url, variants) {
            if (!variants || variants.length < 1) {
                return undefined;
            }
            var parsedUrl = this.parseUrl(url);
            var filters = parsedUrl.filters;
            //find the variant the matches deep link query

            return variants.filter(function (v) {
                var attributes = v.attributes;

                return attributes.reduce(function (attrMatch, attr) {
                    var qValue = filters.query[attr.key];
                    var matchFound = attrMatch && qValue && attr.swatch.displayName.toLowerCase() === qValue[0];
                    return matchFound;
                }, true);
            })[0];
        }
    }]);

    return StoreURL;
}();

var url = exports.url = new StoreURL();